import classNames from "classnames";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { RadioButton } from "primereact/radiobutton";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { validateInputText } from "../../../utilities/ValidateUtil";

export default function P101({ dialog = { dialog: false }, setDialog, showMessages }) {
    const history = useHistory();
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState({
        requestType: "",
    });

    const goPage = (data) => {
        if (data.requestType === "") {
            showMessages("warn", `เกิดข้อผิดพลาด  `, `กรุณาเลือกประเภทงาน`);
            setSubmitted(true);
        } else if (data.requestType === "1") {
            setDialog({ dialog: false });

            history.push({
                pathname: "102",
                state: {
                    action: "บันทึก",
                    form: "101",
                },
            });
        } else if (data.requestType === "2") {
            setDialog({ dialog: false });
            history.push("/103");
        }
    };

    const renderFooter = () => {
        return (
            <div style={{ textAlign: "right" }}>
                <Button label="ตกลง" icon="pi pi-save" onClick={() => goPage(data)} autoFocus className="p-button p-button-success" />
                <Button label="ยกเลิก" icon="pi pi-times" onClick={() => setDialog({ dialog: false })} className="p-button p-button-danger" />
            </div>
        );
    };

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    return (
        <>
            <Dialog
                header="เพิ่มใบแจ้งฯใหม่"
                visible={dialog.dialog}
                style={{ width: "50vw" }}
                className="p-fluid ___widthDialog"
                footer={renderFooter()}
                onHide={() => setDialog(false)}
                blockScroll={true}
                //  maximizable={true}
            >
                <div className="p-grid crud-demo" style={{ marginTop: 10 }}>
                    <div className="p-col-12">
                        <div className="card">
                            <div className="p-grid p-fluid">
                                <div className="p-col-12 p-md-1"></div>
                                <div className="p-col-12 p-md-3">ประเภทงาน</div>
                                <div className="p-col-12 p-md-8">
                                    <div className="p-grid p-fluid">
                                        <div className="p-col-12 p-md-4">
                                            <div className="p-field-radiobutton">
                                                <RadioButton
                                                    inputId={"requestType_1"}
                                                    name={"requestType_1"}
                                                    id={"requestType_1"}
                                                    value="1"
                                                    key={"requestType_1"}
                                                    checked={data.requestType === "1" ? true : false}
                                                    onChange={(e) => onInputTextChange(e, "requestType")}
                                                    className={classNames({ "p-invalid": !data.requestType })}
                                                />
                                                <label htmlFor={"requestType_1"}>งานใหม่</label>
                                            </div>
                                        </div>
                                        <div className="p-col-12 p-md-5">
                                            <div className="p-field-radiobutton">
                                                <RadioButton
                                                    inputId={"requestType_2"}
                                                    name={"requestType_2"}
                                                    id={"requestType_2"}
                                                    value="2"
                                                    key={"requestType_2"}
                                                    checked={data.requestType === "2" ? true : false}
                                                    onChange={(e) => onInputTextChange(e, "requestType")}
                                                    className={classNames({ "p-invalid": !data.requestType })}
                                                />
                                                <label htmlFor={"_2"}>งานสั่งการเฉพาะอย่าง</label>
                                            </div>
                                        </div>
                                    </div>
                                    {submitted && !data.requestType && validateInputText("requestType", "ประเภทงาน")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
